export enum ProfileSettings {
  ProfileId = "xl_ProfileId",
  LicenseFlag = "xl_LicenseFlag",
  AnalyticalLicenseFlag = "xl_AnalyticalLicenseFlag",
  UniversalAnalyticsFlag = "xl_UniversalAnalyticsFlag",
  IsBasicAccessToAssetAndOrganizationsLicensed = "xl_IsBasicAccessToAssetAndOrganizationsLicensed",
  IsUniverseAnalyticsDownloadAllowed = "xl_IsUniverseAnalyticsDownloadAllowed",
  LstGetFunctionCustomAttributeName = "xl_LstGetFunctionCustomAttributeName",
  LstPmeIndex = "xl_LstPmeIndex",
  DtMeasurement = "xl_DtMeasurement",
  DtCurrencies = "xl_DtCurrencies",
  DtAlrternateBaseCurrencies = "xl_DtAlrternateBaseCurrencies",
  CurrencyHedgeList = "xl_CurrencyHedgeList",
}

export enum UserSettings {
  LstGetFunctionAttributeName = "xl_LstGetFunctionAttributeName",
  InvestmentBatchCount = "xl_InvestmentBatchCount",
  PortfolioBatchCount = "xl_PortfolioBatchCount",
  InvestorBatchCount = "xl_InvestorBatchCount",
  RefreshTokenTimer = "xl_RefreshTokenTimer",
  UABatchCount = "xl_UABatchCount",
  CfarInvestmentBatchCount = "xl_CfarInvestmentBatchCount",
  CfarPortfolioBatchCount = "xl_CfarPortfolioBatchCount",
}

export enum WorkbookSettings {
  SheetOptions = "xl_SheetOption",
  ErrorHandlingType = "xl_IsBurgissError",
  SheetState = "xl_SheetState",
}
